import { BaseService } from '../base';
import { makeObservable, observable, action, autorun, runInAction } from 'mobx';
import { setFullLoadingOnly } from '@/utils/common';
import Agreement from '../agreement/interface';
import { IPresignedUrlParams } from './type';
import { sendUserAction, UserActions } from '@/utils/v2/idap';

export class GeneralService extends BaseService {
  @observable prevPath: string = '';
  @observable nextPath: string = '';
  @observable pathHistory: string[] = [];

  @observable loading: Record<string, boolean> = {};

  constructor() {
    super();
    makeObservable(this);
    autorun(() => {
      if (this.prevPath !== this.nextPath) {
        setFullLoadingOnly();
        runInAction(() => {
          this.pathHistory.push(this.nextPath);
          this.prevPath = this.nextPath;
        });
      }
    });
  }

  @action
  updatePath(path: string) {
    this.nextPath = path;
  }

  getPresignedUrl = async (params: IPresignedUrlParams) => {
    try {
      sendUserAction(UserActions.CommonProcesses.CallPresignedUrl, params);
      const { code, result } = await this.post(Agreement.API.presigned_url, {
        body: params,
      });
      if (code === 0) {
        return result.presigned_url;
      }
      sendUserAction(UserActions.CommonProcesses.CallPresignedUrlError, { code });
    } catch (error) {
      console.error('presigned url error :', error);
      sendUserAction(UserActions.CommonProcesses.CallPresignedUrlError, { code: -1 });
    }
    return '';
  };
}
